angular.module("questionarioAdv.module")
  .component("cliente", {
    templateUrl: "ng/components/questionarioAdv/cliente/cliente.view.html",
    bindings: {
      model: "=",
      exportValidationComponent: '&',
      isPagoDopo: '<',
      listQuestions: '=',
      responseQuestionario: '='
    },
    controllerAs: 'clienteCtrl',
    controller: Cliente
  })

function Cliente(
  $typeDomainService,
  Documento,
  $scope,
  $rootScope,
  $istatService,
  $timeout,
  $configService,
  $financialApiService,
  $download
) {
  var self = this;
  self.validationObj = {
    documentDate: {
      disabledDays: [0],
      disabledDates: [
        "01-01",
        "06-01",
        "25-04",
        "01-05",
        "02-06",
        "15-08",
        "01-11",
        "08-12",
        "25-12",
        "26-12"
      ]
    }
  }

  self.$onInit = function () {
    self.catena = [];
    self.listOfElementMultiSelect = [];
    self.linkPep = '/uni/download/service-infos/' +
      encodeURIComponent('GLOSSARIO') + '/';
    self.tomorrow = moment()
      .add(1, "days")
      .format("DD/MM/YYYY");
    self.today = self.getTodaysDate();
    self.supportModel = {

      professione: null,
      professionePrec: null,
      settore: null,
      catena: null,
      tipoCli: null,
      originePatrimonio: null,
      caricaIstituzionale: null,
      firmaDigitalePersonale: null,
      rapportoPep: null,
      origineUtilizFondi: null,
      areaGeoSvolgimento: null,
      areaGeoCliente: null,
      relazioneTitCli: null,
      waitSae: false,
      waitRae: false,
      origineUtilizFondi: null,
      dropdown: {
        sae: [],
        rae: []
      }

    }
    if (self.model.common && self.model.common.sedeLegale && self.model.common.sedeLegale.stato) {
      self.model.common.sedeLegale.stato.name = self.model.common.sedeLegale.stato.name && self.model.common.sedeLegale.stato.name.toUpperCase();
    }
    if (self.model.persona && self.model.persona.domicilio && self.model.persona.domicilio.stato && self.model.persona.domicilio.stato.name) {
      self.model.persona.domicilio.stato.name = self.model.persona.domicilio.stato.name.toUpperCase()
    }
    self.listaNomeComuni = {
      rilascio: [],
      areaGeografica: [],
      areaGeograficaCli: [],
      areaGeograficaFor: []
    }
    if (self.model.persona && self.model.persona.documento && self.model.persona.documento.numero) {
      self.model.persona.documento = Documento.build(self.model.persona.documento);

      self.listaNomeRilascio = Documento.getEntiRilascio(
        self.model.persona.documento.tipo
      );
    } else {
      self.model.persona.documento = Documento.build();
    }
    self.dropdown = {
      tipiDocumento: []
    }
    self.mapComuni = $rootScope.comuniMap;
    self.listaNazioni = [];
    self.listaNazioni = $rootScope.nazioniEstere;
    getListaProvince();
    getListNazioni()
    getListaDocumenti();
    setDefaulValue();
    validateComponent();
    $timeout(function () {
      self.showMultiSelect = true;
      $timeout(() => {
        self.listOfElementMultiSelect = self.model.azienda.catena
      }, 3500)
    }, 200)


    if (self.model.azienda.visible || self.model.coc.visible) {
      self.supportModel.waitRae = true;
      self.supportModel.waitSae = true;
      getDomainForUpdateDescription();
    }

  }

  self.downloadLinkPep = () => {

    $download.getGenericDownload(self.linkPep)
      .then(function (response) {
        console.log(response);
      })
  }


  self.radioModify = function (tipo, valore) {
    if (tipo == 'pep') {
      if (!valore) {
        self.supportModel.caricaIstituzionale = null;
      }
    }

    validateComponent();
  }


  var getListaDocumenti = function () {

    $typeDomainService
      .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
      .then(function (response) {
        self.dropdown.tipiDocumento = response.domainList;
        for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
          if (self.dropdown.tipiDocumento[i].value == "CAE") {
            self.dropdown.tipiDocumento[i].order = 40;
          }
          if (self.dropdown.tipiDocumento[i].value == "CAI") {
            self.dropdown.tipiDocumento[i].order = 10;
          }
          if (self.dropdown.tipiDocumento[i].value == "CIE") {
            self.dropdown.tipiDocumento[i].order = 20;
          }
          if (self.dropdown.tipiDocumento[i].value == "NCE") {
            self.dropdown.tipiDocumento[i].order = 30;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAM") {
            self.dropdown.tipiDocumento[i].order = 50;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAS") {
            self.dropdown.tipiDocumento[i].order = 80;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAT") {
            self.dropdown.tipiDocumento[i].order = 60;
          }
          if (self.dropdown.tipiDocumento[i].value == "UCO") {
            self.dropdown.tipiDocumento[i].order = 70;
          }

        }
      });
  }


  self.getTodaysDate = function () {

    return moment().format("DD/MM/YYYY");
  }

  self.setDocNumRegex = function () {
    self.regExpDocumento = self.model.persona.documento.tipo;
    self.listaNomeRilascio = Documento.getEntiRilascio(
      self.model.persona.documento.tipo
    );
    self.model.persona.documento.numero = null;
    self.refreshRegex = true;
    $timeout(function () {
      self.refreshRegex = false;
      validateComponent();
    }, 20)
    if (self.isPagoDopo) {
      return; // se pagodopo non effettuare la chiamata per ottenere le info sui documenti
    }
    $financialApiService
      .getIdentityDocument(
        self.model.common.ndg,
        self.model.persona.documento.tipo
      )
      .then(function (response) {
        if (response.success) {
          self.model.persona.documento.dataRilascio =
            response.document.dataRilascio;
          self.model.persona.documento.dataScadenza =
            response.document.dataScadenza;
          self.model.persona.documento.luogoEsteso = {
            nome: response.document.luogo,
          };
          self.model.persona.documento.enteRilascio.name =
            response.document.enteRilascio;
          self.model.persona.documento.provincia =
            response.document.provincia;
          self.model.persona.documento.numero = response.document.numero;
          sefl.model.persona.documento.id = response.document.id
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  var getListaProvince = function () {
    self.listaProvince = self.mapComuni
      .map(function (comune) {
        return comune.sigla;
      })
      .filter(function (siglaComune) {
        return siglaComune != "";
      })
      .sort()
      .reduce(function (result, nextItem) {
        return result.includes(nextItem) ? result : result.concat(nextItem);
      }, []);
    self.listaProvince.push("EE");

  }

  self.creaComuni = function (tipo, provincia) {
    if (provincia != 'EE') {
      self.listaNomeComuni[tipo] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
    }
    validateComponent();
  }

  var getListNazioni = function () {
    $istatService.getNazioni()
      .then(function (response) {
        self.listaNazioni = response.domainList.filter(
          function (element) {
            return !element.deleted
          });
        self.nationCitizenship = response.domainList.filter(
          function (element) {
            return !element.deleted
          }).map(function (element) {
            return element.name.toUpperCase();
          }).sort();
      })
  }

  var setDefaulValue = function () {
    self.supportModel.professione = self.model.persona.professione && self.model.persona.professione.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.professionePrec = self.model.persona.professionePrec && self.model.persona.professionePrec.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.settore = self.model.persona.settore && self.model.persona.settore.find(function (element) {
      return element.selected == true;
    })

    self.catena = self.model.azienda.catena && self.model.azienda.catena.filter(function (element) {
      return element.selected == true;
    })

    self.supportModel.tipoCli = self.model.azienda.tipoCli && self.model.azienda.tipoCli.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.areaGeoSvolgimento = self.model.persona.area && self.model.persona.area.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.areaGeoCliente = self.model.azienda.areaCli && self.model.azienda.areaCli.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.areaGeoFornitore = self.model.azienda.areaFor && self.model.azienda.areaFor.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.originePatrimonio = self.model.common.originePatrimonio && self.model.common.originePatrimonio.find(function (element) {
      return element.selected == true;
    })

    self.supportModel.caricaIstituzionale = self.model.persona.pep && self.model.persona.pep.carica && self.model.persona.pep.carica
      .find(function (element) {
        return element.selected == true;
      })

    self.supportModel.rapportoPep = self.model.persona.pep && self.model.persona.pep.relazione && self.model.persona.pep.relazione
      .find(function (element) {
        return element.selected == true;
      })

    self.supportModel.origineUtilizFondi = self.model.persona.pep && self.model.persona.pep.origineFondi && self.model.persona.pep.origineFondi
      .find(function (element) {
        return element.selected == true;
      })

    self.supportModel.relazioneTitCli = self.model.common.relazioneTitCli && self.model.common.relazioneTitCli.find(function (element) {
      return element.selected == true;
    })

  }

  self.handleChange = function (tipo, subType, valueSelected) {
    if (tipo == 'azienda' && subType == 'catena') {
      self.catena = valueSelected;
      var testFiduciaria = valueSelected && valueSelected.some(function (element) {
        return element.value == "2"
      })
      if (testFiduciaria) {
        self.responseQuestionario.warningFiduciara = true;
        self.listQuestions.fiduciarie.fiduciarie.forEach(function (element) {
          element.annullatoFe = false;
        })
        self.listQuestions.fiducianti.fiducianti.forEach(function (element) {
          element.annullatoFe = false;
        })

      } else {
        self.responseQuestionario.warningFiduciara = false;
        self.listQuestions.fiduciarie.fiduciarie.forEach(function (element) {
          element.annullatoFe = true;
        })
        self.listQuestions.fiducianti.fiducianti.forEach(function (element) {
          element.annullatoFe = true;
        })
      }
      self.model[tipo][subType].forEach(function (element) {
        element.selected = valueSelected.some(function (elementSelected) {
          return elementSelected.value == element.value
        })
      })
    } else {
      if (subType) {
        self.model[tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })

      } else {
        self.model[tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }

    }


    if (tipo === 'persona' && subType === 'professione') {
      if (valueSelected.name === "Casalinga" || valueSelected.name === "Pensionato" || valueSelected.name === "Non occupato") {
        self.enablePreviusJob = true;
      } else {
        self.enablePreviusJob = false;
      }
    }

    validateComponent();
  }

  self.pepChange = function (tipo, subType, valueSelected) {
    if (subType == 'paeseOrigine') {
      validateComponent();
      return;
    }
    self.model.persona[tipo][subType].forEach(function (element) {
      if (element.value == valueSelected.value) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    })
    validateComponent();
  }

  var validateComponent = function () {
    $timeout(function () {
      if (self.model.azienda.visible) {
        var formValidity = $scope.clientForm.$valid && !!self.catena.length
        console.log("Il form cliente è:", formValidity);
        self.exportValidationComponent({
          valid: formValidity
        })

      } else {
        console.log("Il form cliente è:", $scope.clientForm.$valid);
        self.exportValidationComponent({
          valid: $scope.clientForm.$valid
        })
      }


    }, 500)
  }


  self.handleChangeClassicVersion = function (name, value) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.model.persona.documento.numero = value
        break;

      case 'dataScadenza':
        self.model.persona.documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.model.persona.documento.dataRilascio = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  self.getEndDate = function (dataRilascio) {
    if (dataRilascio) {
      var tipoDocumento = self.model.persona.documento.tipo;
      var dataNascita = self.model.common.data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.clientForm && $scope.clientForm.dataScadenza && moment.duration(moment(self.model.persona.documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.clientForm.dataScadenza.$valid = false;
        }
        if ($scope.clientForm && $scope.clientForm.dataScadenza && moment.duration(moment(self.model.persona.documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.clientForm.dataScadenza.$valid = false;
          $scope.clientForm.dataScadenza.$setValidity("dataScadenza", false);
        } else {
          $scope.clientForm && $scope.clientForm.dataScadenza && $scope.clientForm.dataScadenza.$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.model.persona.documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.clientForm.dataScadenza.$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  self.getSaeDescription = function (saeCode) {

    if (self.supportModel.dropdown.sae) {
      var result = self.supportModel.dropdown.sae.find(function (sae) {
        return sae.id == saeCode
      });
      return result ? result.id + ' - ' + result.description : '-';
    } else return '-';

  }

  self.getRaeDescription = function (raeCode) {

    if (self.supportModel.dropdown.rae) {
      var result = self.supportModel.dropdown.rae.find(function (rae) {
        return rae.id == raeCode
      });
      return result ? result.id + ' - ' + result.description : '-';
    } else return '-';

  }

  var getDomainForUpdateDescription = function () {
    $typeDomainService
      .getSaeByLegalStatus(self.model.common.legalForm)
      .then(function (saeList) {
        self.supportModel.dropdown.sae = saeList;
        self.supportModel.waitSae = false;

      });

    var sae = ""

    if (self.model.azienda.visible) {
      sae = self.model.azienda.sae
    } else {
      sae = self.model.coc.sae
    }

    $typeDomainService
      .getRaeBySae(sae)
      .then(function (raeList) {
        self.supportModel.dropdown.rae = raeList;
        self.supportModel.waitRae = false;
      });
  }
}